import api from '@/services/utils/base';

export default class ReferralProgram {
  getReferred(params:any) {
    return api
      .get('user/referrals/referred-users', {
        params
      })
      .then((res: any) => {
        return Promise.resolve(res.data.payload);
      })
      .catch((err: any) => {
        return Promise.reject(err);
      });
  }

  getBalance(params:any) {
    return api
      .get('user/referrals/balance-history',{
        params
      })
      .then((res: any) => {
        return Promise.resolve(res.data.payload);
      })
      .catch((err: any) => {
        return Promise.reject(err);
      });
  }
}
